<template>
    <div>
        <div id="page">
            <Header></Header>

        <div class="detail">
            <h1 class="title">{{ questionInfo.title }}</h1>
            <div class="content">{{ questionInfo.content }}</div>
            <div class="info">
                <div class="num">{{ questionInfo.number }}条回答</div>
                <div class="keep" v-if="questionInfo.iscollect == 0" @click="keep"></div>
                <div class="keep on" v-else-if="questionInfo.iscollect == 1" @click="unKeep"></div>
                <div class="date">{{ questionInfo.re_create_time }}</div>
            </div>
            <div v-for="(item, index) in answerList">
                <div class="hui-info">
                    <div class="right">
                        <div class="status" v-if="item.is_best == 1">最佳答案</div>
                        <div class="btn" v-else @click="doBest(item.question_id, item.answer_id)">设为最佳答案</div>
                    </div>
                    <div class="head"><img :src="item.reply_answer_member_head" alt=""></div>
                    <div class="reply" v-if="loginStatus == true" @click="showReply(index)">回复评论</div>
<!--                    <div class="name">{{ item.reply_answer_member_name }}</div>-->
                </div>
                <div class="detail-cont">
                    {{ item.answer_content }}
                </div>
                <div class="reply-bar" v-show="item.re_goreply == true" :ref="'reply' + index">
                    <textarea class="inp" v-model="replyVal"></textarea>
                    <div class="btns"><a class="btn confirm" href="javascript:;" @click="submitReply(item.question_id)">提交</a><a class="btn cancel" href="javascript:;" @click="closeReply(index)">取消</a></div>
                </div>
            </div>
        </div>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>


    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import { List, Toast } from 'vant';

    export default {
        name: "QuestionDetail",
        data () {
            return {
                tabActive: 0,
                loginStatus: false,
                questionInfo: {},
                answerList: [],
                replyVal: ''
            }
        },
        components: {
            Header, Footer,
            [Toast.name]: Toast,
            [List.name]: List
        },
        mounted () {
            this.sn = this.$route.query.sn;
            this.getQuestion();
            this.checkLogined();
        },
        methods: {
            checkLogined () {
                var _this = this;
                _this.api.getUserInfo().then(function(response){
                    if (response.member_info && Object.keys(response.member_info).length > 0) {
                        _this.loginStatus = true;
                    } else {
                        _this.loginStatus = false;
                    }
                })
            },
            getQuestion () {
                const _this = this;
                _this.api.getQuestionView({
                    sn: _this.sn,
                }).then(function(response){
                    _this.questionInfo = response.question_info;
                    _this.answerList = response.answer_list;
                    _this.questionInfo.re_create_time = _this.formatTime(_this.questionInfo.create_time, '{y}-{m}-{d}');
                    for (let i in _this.answerList) {
                        _this.answerList[i].re_goreply = false
                    }
                })
            },
            doBest(question_id, answer_id){
                const _this = this;
                let params = new FormData();
                params.append('question_id', question_id);
                params.append('answer_id', answer_id);
                _this.api.setBest(params).then(function(response){
                    if (response.status != 1) {
                        Toast(response.msg)
                    } else {
                        _this.getQuestion();
                    }
                })
            },
            changeTab(index){
                this.tabActive = index
            },
            showReply(index){
                this.$refs['reply' + index][0].style.display = 'block'
            },
            closeReply(index){
                this.$refs['reply' + index][0].style.display = 'none';
                _this.replyVal = '';
            },
            submitReply(id){
                const _this = this;
                _this.api.replyQusetion({
                    question_id: id,
                    answer_content: _this.replyVal
                }).then(function(response){
                    Toast(response.msg);
                    _this.replyVal = ''
                })
            },
            keep(){
                const _this = this;
                let params = new FormData();
                params.append('id', _this.questionInfo.question_id);
                params.append('type', 'question');
                _this.api.addCollection(params).then(function(response){
                    Toast(response.msg);
                    _this.getQuestion();
                })
            },
            unKeep(){
                const _this = this;
                let params = new FormData();
                params.append('collection_id', _this.questionInfo.collection_id);
                _this.api.delCollection(params).then(function(response){
                    Toast(response.msg);
                    _this.getQuestion();
                })
            },
        }
    }
</script>


<style scoped>
    .detail {margin: .3rem;background-color: #fff;padding: .3rem;}
    .title {font-size: .28rem;font-weight: bold;color: #1f1f1f;line-height: .34rem;margin-bottom: .2rem;}
    .content {font-size: .24rem;color: #838383;margin-bottom: .2rem;}
    .info {overflow: hidden;font-size: .2rem;color: #838383;}
    .info .num {float: left;padding-left: .4rem;background: url("../assets/images/icon-msg.png") no-repeat left center;-webkit-background-size: .3rem auto;background-size: .3rem auto;margin-right: .5rem;}
    .info .keep {float: left;width: .3rem;height: .3rem;background: url("../assets/images/icon-keep.png") no-repeat center center;-webkit-background-size: contain;background-size: contain;}
    .info .keep.on {background-image: url('../assets/images/icon-keep-on.png');}
    .info .date {float: right;}
    .hui-info {margin-top: .2rem;padding: .2rem 0;border-top: 1px solid #989898;overflow: hidden;}
    .hui-info .head {float: left;width: .6rem;height: .6rem;-webkit-border-radius: .05rem;-moz-border-radius: .05rem;border-radius: .05rem;background-color: #8c8c8c;margin-right: .2rem;}
    .hui-info .name {line-height: .6rem;color: #838383;font-size: .24rem;}
    .hui-info .reply {float: left;line-height: .6rem;font-size: .24rem;color: #00a0e9;}
    .hui-info .right {float: right;line-height: .6rem;font-size: .24rem;color: #00a0e9;}
    .detail-cont {font-size: .24rem;color: #838383;line-height: .34rem;}
    .reply-bar {margin-top: .2rem;}
    .reply-bar .inp {width: 100%;-webkit-border-radius: .05rem;-moz-border-radius: .05rem;border-radius: .05rem;resize: none;padding: .5em 1em;font-size: .24rem;}
    .reply-bar .btns {overflow: hidden;}
    .reply-bar .btn {float: right;width: 1rem;font-size: .2rem;text-align: center;line-height: 2em;margin-left: .15rem;-webkit-border-radius: .02rem;-moz-border-radius: .02rem;border-radius: .02rem;}
    .reply-bar .btn.confirm {background-color: #00a0e9;color: #ffffff;}
    .reply-bar .btn.cancel {background-color: #e8e8e8;}
</style>
